import React, { Component } from 'react';
import _ from 'lodash';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Info } from '../../../assets/svg/info.svg';
import Select from 'react-select';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import LoadingBar from '../../components/global/loadingBar';
import Modal from '../../components/modals';
import { toast } from 'react-toastify';
const getEvent = gql`
	query RootQuery($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			projectTitle
			name
			crew {
				count
				managerIds
				role
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			memoryCards {
				status
				isReceived
				__typename
				qrCode
				type
				isEmpty
			}
		}
	}
`;
const getTenantUsersListForMc = gql`
	query VendorTenantUsersList($filters: TenantUsersFiltersInput) {
		vendorTenantUsersList(filters: $filters) {
			data {
				id
				firstName
				lastName
				email
				isEmailVerified
			}
			totalPages
			totalDocs
			limit
			currentPage
			hasNextPage
			nextPage
		}
	}
`;
const getMemoryCard = gql`
	query MemoryCard($mcIdentifier: String) {
		memoryCard(mcIdentifier: $mcIdentifier) {
			id
			qrCode
			ownerType
			ownerId
			type
			comment {
				_id
				comment
				createdAt
				createdBy
			}
			manufacturerId
			manufacturer
			description
			status
			lastUsedBy {
				tenantId
				workspaceId
				projectId
				projectName
				projectSlNo
				eventId
				eventName
				eventSlNo
				userId
				userName
				usedAt
			}
			createdAt
			updatedBy
			updatedAt
			size
			isReceived
			subStatus
			branch {
				_id
				branchId
			}
		}
	}
`;
const receiveMemoryCard = gql`
	mutation ReceiveMemoryCard(
		$qrCodes: [String!]!
		$workspaceId: String!
		$receivedFrom: LogUserInput!
		$projectId: ID!
		$eventId: ID!
		$isEmpty: Boolean
		$usageType: [UsageType]
	) {
		receiveMemoryCard(
			qrCodes: $qrCodes
			workspaceId: $workspaceId
			receivedFrom: $receivedFrom
			projectId: $projectId
			eventId: $eventId
			isEmpty: $isEmpty
			usageType: $usageType
		) {
			message
		}
	}
`;

class ReceiveMemoryCard extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			qrCode: '',
			qrCodeError: false,
			qrCodeDuplicate: false,
			assignedCrew: null,
			tenantUsersList: {},
			eventDetails: {},
			equipments: [],
			receiveError: false,
			cardTypeOptions: [
				{ value: 'photoCard', label: 'Photo Card' },
				{ value: 'videoCard', label: 'Video Card' },
				{ value: 'photoAndVideoCard', label: 'Photo & Video Card' },
				{ value: 'unknown', label: 'Unknown' },
			],
			cardType: null,
			showBusyModal: false,
			confirmRemap: false,
		};
	}

	timer = null;
	componentDidMount = () => {
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let json = {
			filters: {
				limit: 10000,
				page: 1,
				workspaceIds: this.props.params.workspaceID,
			},
		};

		this.getShootInfo(getEvent, filters);
		this.getTenantUsersListForMc(getTenantUsersListForMc, json);
	};
	componentWillUnmount = () => {
		if (this.timer) {
			clearTimeout(this.timer);
		}
	};
	renderCrew = () => {
		let crewDetails = [];
		_.map(this.state.eventDetails.crewNew, (crew) => {
			if (crew.isCustomUser !== true && crew.userId !== null) {
				let found = undefined;

				let name = '';
				let isManager = false;
				found = _.find(this.state.tenantUsersList, { id: crew.userId });
				if (found) {
					name = `${found.firstName ? found.firstName : ''}${' '}${
						found.lastName ? found.lastName : ''
					}`;
					isManager = crew.isManager === null ? false : crew.isManager;
				}

				let data = { id: crew.userId, name, isManager };

				crewDetails.push(data);
			}

			return crew;
		});

		let arr = [];
		_.forEach(crewDetails, (item, key) => {
			arr.push({ value: item.id, label: item.name });
		});
		return (
			<Select
				className={`cost-select-container zIndex3 w-100p `}
				classNamePrefix="cost-select"
				onChange={(e) => this.handleEditCrewName(e)}
				isSearchable={true}
				options={arr}
				value={
					_.filter(arr, {
						value: this.state.assignedCrew,
					})[0]
				}
			/>
		);
	};
	handleEditCrewName = (e) => {
		this.setState({
			assignedCrew: e.value,
			assignedCrewUserName: e.label,
		});
	};
	handleEditCardType = (e) => {
		this.setState({
			cardType: e.value,
		});
	};
	handleEventChange = (e, name) => {
		this.setState(
			{
				qrCode: e.target.value,
				qrCodeError: false,
				qrCodeErrorMessage: '',
			},
			async () => {
				if (
					_.size(
						_.filter(this.state.equipments, {
							qrCode: e.target.value.toUpperCase(),
						}),
					) > 0
				) {
					this.setState({
						qrCodeError: true,
						qrCodeErrorMessage: 'Memory Card already Scanned',
					});
				} else if (
					_.size(
						_.filter(this.state.eventDetails.memoryCards, {
							qrCode: e.target.value.toUpperCase(),
						}),
					) > 0 &&
					_.filter(this.state.eventDetails.memoryCards, {
						qrCode: e.target.value.toUpperCase(),
					})[0].isReceived &&
					_.size(
						_.filter(this.state.eventDetails.memoryCards, {
							qrCode: e.target.value.toUpperCase(),
							isReceived: false,
						}),
					) === 0
				) {
					this.setState({
						qrCodeError: true,
						qrCodeErrorMessage: 'Memory Card already Received',
					});
				} else if (
					e.target.value !== '' &&
					e.target.value.length >= 8 &&
					_.size(
						_.filter(this.state.equipments, {
							qrCode: e.target.value.toUpperCase(),
						}),
					) == 0
				) {
					let json = { mcIdentifier: e.target.value.toUpperCase() };
					await this.getMemoryCardInfo(getMemoryCard, json, true);
				}
			},
		);
	};
	renderSummary = () => {
		let data = _.filter(this.state.eventDetails.memoryCards, {
			isReceived: false,
		});

		return _.size(data) > 0 ? (
			<div className="assign-hdd-item ">
				<div className="column column-20w">
					<span>QR Code</span>
					<span>Type</span>
					<span></span>
					{/* <span>damage</span> */}
				</div>
				{_.map(
					data,

					(equipment, key) => {
						if (
							_.size(
								_.filter(this.state.equipments, {
									qrCode: equipment.qrCode,
								}),
							) === 0
						)
							return (
								<div
									className="hitem column-20w listHitem"
									style={{
										color: '#fff',
									}}
								>
									<span>{equipment.qrCode}</span>
									<span>{equipment.type}</span>
									<span></span>
								</div>
							);
					},
				)}
			</div>
		) : (
			''
		);
	};
	isDisabled = () => {
		let busyCards = [];
		_.map(this.state.equipments, (mc, key) => {
			if (
				_.size(
					_.filter(this.state.eventDetails.memoryCards, {
						qrCode: mc.qrCode,
					}),
				) == 0
			) {
				busyCards.push(mc);
			}
		});
		if (
			_.size(this.state.equipments) == 0 ||
			this.state.assignedCrew == null ||
			(_.size(busyCards) > 0 && this.state.confirmRemap == false)
		) {
			return true;
		} else {
			return false;
		}
	};
	handleAssignEquipment = async (e) => {
		this.setState({ isReceiveLoading: true });
		let eventId = this.props.params.shootID;
		let projectId = this.props.params.projectID;
		let workspaceId = this.props.params.workspaceID;
		let resp;
		let resp2;

		let usageType;
		usageType =
			this.state.cardType === 'photoAndVideoCard'
				? ['photoCard', 'videoCard']
				: [this.state.cardType];

		let isEmptyList = [];
		isEmptyList = _.filter(this.state.equipments, { isEmpty: true });
		if (_.size(isEmptyList) > 0) {
			let qrCodes = [];
			_.forEach(isEmptyList, (equipment, key) => {
				qrCodes.push(equipment.qrCode);
			});
			let receiveMCVariables = {
				qrCodes,
				receivedFrom: {
					id: this.state.assignedCrew,
					name: this.state.assignedCrewUserName,
				},
				projectId,
				eventId,
				workspaceId,
				usageType,
				isEmpty: true,
			};

			resp = await this.receiveMemoryCard(receiveMemoryCard, receiveMCVariables, true);
		}
		let isNotEmptyList = [];
		isNotEmptyList = _.filter(this.state.equipments, { isEmpty: false });
		if (_.size(isNotEmptyList) > 0) {
			let qrCodes = [];
			_.forEach(isNotEmptyList, (equipment, key) => {
				qrCodes.push(equipment.qrCode);
			});
			let receiveMCVariables = {
				qrCodes,
				receivedFrom: {
					id: this.state.assignedCrew,
					name: this.state.assignedCrewUserName,
				},
				projectId,
				eventId,
				workspaceId,
				usageType,
			};

			resp2 = await this.receiveMemoryCard(receiveMemoryCard, receiveMCVariables, true);
		}
		if (resp2 === false && resp === false) {
			toast.error('Failed to receive Memory Card!', {
				position: 'top-right',
				theme: 'colored',
				autoClose: 2000,
			});
		} else if (resp2 === false || resp === false) {
			toast.error('Failed to receive some Memory Card!', {
				position: 'top-right',
				theme: 'colored',
				autoClose: 2000,
			});
		}
		if (resp !== false && resp2 !== false) {
			toast.success('Memory Card received!', {
				position: 'top-right',
				theme: 'colored',
				autoClose: 2000,
			});
		}
		this.timer = setTimeout(() => {
			window.location.reload();
		}, 2000);
	};

	deleteItem = (e, qrCode) => {
		let equipments = [...this.state.equipments];
		this.setState({
			equipments: _.filter(equipments, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};
	goBack = (e) => {
		this.props.navigate(`/${this.props.params.vendorID}/shoots`);
	};
	handleBusyInfo = (e) => {
		this.setState({
			showBusyModal: true,
		});
	};
	handleToggleisEmpty = (isEmpty, index) => {
		let equipments = this.state.equipments;
		equipments[index].isEmpty = isEmpty;

		this.setState({ equipments });
	};

	render() {
		let busyCards = [];
		_.map(this.state.equipments, (mc, key) => {
			if (
				_.size(
					_.filter(this.state.eventDetails.memoryCards, {
						qrCode: mc.qrCode,
					}),
				) == 0
			) {
				busyCards.push(mc);
			}
		});

		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div className="assign-receive-container">
						<div className="arc-header">
							{/* <div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div> */}
							<div className="arch-item">
								<span>Workspace</span>
								<b>{this.props.params.workspaceID}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Project</span>
								<b>{this.state.eventDetails.projectTitle}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Shoot</span>
								<b>{this.state.eventDetails.name}</b>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>
							<div className="arch-item">
								<span>Receive Memory Cards</span>
							</div>
						</div>
						<div className="arc-body" style={{ flexDirection: 'row-reverse' }}>
							<div className="arcb-left">
								<div
									className="qrhitem column-20w"
									style={{
										display: 'flex',
										flexDirection: 'column',
									}}
								>
									<input
										value={this.state.qrCode}
										placeholder="Type QR Code"
										autoFocus={true}
										onChange={(e) => this.handleEventChange(e, 'qrCode')}
									/>
									{this.state.isEQFetching ? (
										<div className={'loading-btn'}>
											<LoadingBar />
										</div>
									) : (
										''
									)}
									{this.state.qrCodeError ? (
										<p>{this.state.qrCodeErrorMessage}</p>
									) : (
										''
									)}
								</div>
								<div className="arcbl-list">
									<div className="assign-hdd-item ">
										<div className="column column-20w">
											<span>Qr Code</span>
											<span>description</span>
											<span>type</span>
											<span>empty card</span>

											<span></span>

											{/* <span>damage</span> */}
										</div>

										{_.size(this.state.equipments) > 0 ? (
											_.map(
												this.state.equipments,

												(equipment, key) => {
													return (
														<div
															className="hitem column-20w listHitem"
															style={{
																color:
																	_.size(busyCards) > 0
																		? 'orange'
																		: '#fff',
															}}
														>
															<span
																style={{
																	display: 'flex',
																	alignItems: 'center',
																}}
																onClick={(e) =>
																	_.size(busyCards) > 0 &&
																	this.handleBusyInfo(e)
																}
															>
																{equipment.qrCode}
																{_.size(
																	_.filter(
																		this.state.eventDetails
																			.memoryCards,
																		{
																			qrCode: equipment.qrCode,
																		},
																	),
																) == 0 ? (
																	<b
																		style={{
																			display: 'flex',
																			alignItems: 'center',
																			marginLeft: 5,
																		}}
																		className={'orange-info'}
																	>
																		<Info />
																	</b>
																) : (
																	''
																)}
															</span>
															<span
																onClick={(e) =>
																	_.size(busyCards) > 0 &&
																	this.handleBusyInfo(e)
																}
															>
																{equipment.description}
															</span>
															<span
																onClick={(e) =>
																	_.size(busyCards) > 0 &&
																	this.handleBusyInfo(e)
																}
															>
																{equipment.type}
															</span>
															<span>
																<label class="checkbox-container">
																	<input
																		type="checkbox"
																		onClick={() =>
																			this.handleToggleisEmpty(
																				!equipment.isEmpty,
																				key,
																			)
																		}
																		checked={
																			_.has(
																				equipment,
																				'isEmpty',
																			)
																				? equipment.isEmpty
																				: false
																		}
																	/>
																	<span
																		class="checkmark"
																		style={{ minWidth: '19px' }}
																	></span>
																</label>
															</span>

															<span
																style={{
																	cursor: 'pointer',
																}}
																onClick={(e) =>
																	this.deleteItem(
																		e,
																		equipment.qrCode,
																	)
																}
															>
																{' '}
																<Delete />
															</span>
														</div>
													);
												},
											)
										) : (
											<div className="empty">
												<p>
													No Memory Card Added <br />
													Please scan or type in the Memory Card ID
												</p>
											</div>
										)}
									</div>
								</div>
								<div className="btn">
									<a
										className={
											this.isDisabled()
												? 'add-edit-btn disabled'
												: 'add-edit-btn'
										}
										onClick={(e) => {
											if (!this.isDisabled()) {
												this.handleAssignEquipment();
											}
										}}
									>
										Receive Memory Cards
									</a>
								</div>
							</div>
							<div className="arcb-right">
								{/* <div className="arcbr-top-inputs">
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Workspace</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.props.params.workspaceID}
												//value={this.props.params.workspaceID}
												isDisabled={true}
											/>
										</div>
									</div>

									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Project</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.projectTitle}
												isDisabled={true}
											/>
										</div>
									</div>
									<div className="project-add-edit-popup-body-item">
										<div className="floating-select-container">
											<label>Event</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCrewName(e)}
												isSearchable={true}
												placeholder={this.state.eventDetails.name}
												isDisabled={true}
											/>
										</div>
									</div>
								</div> */}
								<div className="arcbr-bottom-inputs" style={{ marginTop: 0 }}>
									<div
										className="project-add-edit-popup-body-item"
										style={{
											display: 'flex',
											flexDirection: 'row',
											gap: 20,
										}}
									>
										<div
											className="floating-select-container"
											style={{ width: '50%' }}
										>
											<label>Received from*</label>
											{this.renderCrew()}
										</div>

										<div
											className="floating-select-container"
											style={{ width: '50%' }}
										>
											<label>Photo/video card</label>
											<Select
												className={`cost-select-container zIndex3 w-100p `}
												classNamePrefix="cost-select"
												onChange={(e) => this.handleEditCardType(e)}
												isSearchable={true}
												options={this.state.cardTypeOptions}
												value={
													_.filter(this.state.cardTypeOptions, {
														value: this.state.cardType,
													})[0]
												}
											/>
										</div>
									</div>
								</div>

								<div className="summary">{this.renderSummary()}</div>
							</div>
						</div>
						<Modal
							handleClose={() => this.setState({ showBusyModal: false })}
							show={this.state.showBusyModal}
							modalType={'center'}
						>
							<div className="busy-modal">
								<div className="bm-header">MC Error</div>
								<div className="bm-body">
									<div
										style={{
											maxHeight: '80%',
											width: '100%',
											overflowY: 'scroll',
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<div
											style={{
												width: '100%',

												display: 'flex',
												flexDirection: 'row',
											}}
										>
											<span
												style={{
													width: '25%',
													color: '#707070',
													borderBottom: '1px solid #707070',
													paddingBottom: 5,
												}}
											>
												QrCode
											</span>
											<span
												style={{
													width: '30%',
													color: '#707070',
													borderBottom: '1px solid #707070',
													paddingBottom: 5,
												}}
											>
												Project Name
											</span>
											<span
												style={{
													width: '30%',
													color: '#707070',
													borderBottom: '1px solid #707070',
													paddingBottom: 5,
												}}
											>
												Event Name
											</span>
											<span
												style={{
													width: '15%',
													color: '#707070',
													borderBottom: '1px solid #707070',
													paddingBottom: 5,
												}}
											>
												Status
											</span>
										</div>
										{_.map(busyCards, (mc, k) => {
											return (
												<div
													style={{
														width: '100%',
														display: 'flex',
														flexDirection: 'row',
														margin: '5px 0px',
													}}
												>
													<span
														style={{
															width: '25%',
															color: '#fff',
															paddingRight: '8px',
														}}
													>
														{mc.qrCode}
													</span>
													<span
														style={{
															width: '30%',
															color: '#fff',
															paddingRight: '8px',
														}}
													>
														{mc.status === 'busy' &&
														_.has(mc.lastUsedBy, 'projectName')
															? mc.lastUsedBy.projectName
															: ''}
													</span>
													<span
														style={{
															width: '30%',
															color: '#fff',
															paddingRight: '8px',
														}}
													>
														{mc.status === 'busy' &&
														_.has(mc.lastUsedBy, 'eventName')
															? mc.lastUsedBy.eventName
															: ''}
													</span>
													<span
														style={{
															width: '15%',
															color: '#fff',
														}}
													>
														{mc.status ? mc.status : ''}
													</span>
												</div>
											);
										})}
									</div>
									<p>
										{_.size(busyCards)} Memory{' '}
										{`card${_.size(busyCards) > 1 ? 's' : ''}`} are not assigned
										to this shoot. Do you still wish to go ahead and receive
										them for this shoot?
									</p>
								</div>
								<div className="bm-footer">
									<a
										onClick={() =>
											this.setState({
												showBusyModal: false,
											})
										}
									>
										No, Cancel
									</a>
									<a
										onClick={() =>
											this.setState({
												showBusyModal: false,
												confirmRemap: true,
											})
										}
										style={{
											margin: '0px 15px',
											background:
												'linear-gradient(90deg, #9256D9 0%, #5F55EC 100%)',
											color: '#fff',
										}}
									>
										Yes, Receive
									</a>
								</div>
							</div>
						</Modal>
					</div>
				)}
			</>
		);
	}
}

export default withRouter(ReceiveMemoryCard);
